import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import { executeQueryJSON } from '@arcgis/core/rest/query';
import Query from '@arcgis/core/rest/support/Query';
import { MapService } from '@services/map.service';
import { PlanparcelDataService } from '@services/planparcel-data.service';

@Component({
    selector: 'app-eng-plan-edit',
    // standalone: true,
    // imports: [],
    templateUrl: './eng-plan-edit.component.html',
    styleUrl: './eng-plan-edit.component.scss'
})
export class EngPlanEditComponent {
    baladeyaNameOptions: string[] = [];
    baladeyaGeometry = {};
    neighNameOptions: string[] = [];
    neighGeom = {};
    planNameOptions: string[] = [];
    planGeom = {};

    objectid: number;
    parcelPlan: string = '';
    parcelAsbuilt: string = '';
    MAPhotographyZone: string = '';
    planCorrect: string = '';
    zoneCode: string = '';
    comparison: string = '';
    balady2: string = '';
    F3D: string = '';
    planBaladya: string = '';
    parcelCount: number;
    parcelArea: number;
    planFeature: any;
    flyr: FeatureLayer;

    constructor(
        private http: HttpClient,
        private mapService: MapService,
        private planparcel: PlanparcelDataService
    ) { }

    ngOnInit() {
        this.flyr = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5'
        });
        // url: 'https://144.76.146.59:6443/arcgis/rest/services/AmanaFinalTestt/AmanaFinalTestt/FeatureServer/6'});
        this.flyr.orderBy = [
            {
                field: 'SUBDIVISIONNAME_AR',
                order: 'descending' // "descending" | "ascending"
            }
        ];

        this.queryBaladeyaNames();
    }

    queryBaladeyaNames() {
        //   debugger;
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=BELEDIYE';
        const queryObject = new Query({
            where: '1=1',
            returnGeometry: true,
            outFields: ['BELEDIYE']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.baladeyaNameOptions = results.features.map(
                (feature) => feature.attributes.BELEDIYE
            );
            results.features.forEach((feature) => {
                this.baladeyaGeometry[feature.attributes.BELEDIYE] =
                    feature.geometry;
            });

            // console.log(this.baladeyaGeometry)
        });
    }

    queryNeighNames(baladeya: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=NEIGH_NAME';
        const queryObject = new Query({
            where: `BELEDIYE = N'${baladeya}'`, // Assuming BELEDIYE is the field name for baladeya
            returnGeometry: true,
            outFields: ['NEIGH_NAME']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.neighNameOptions = results.features.map(
                (feature) => feature.attributes.NEIGH_NAME
            );
            results.features.forEach((feature) => {
                this.neighGeom[feature.attributes.NEIGH_NAME] =
                    feature.geometry;
            });
        });
    }

    queryPlanNames(neigh: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=SUBDIVISIONNAME_AR';
        const queryObject = new Query({
            where: `Neigh_region = N'${neigh}'`,
            returnGeometry: true,
            outFields: ['SUBDIVISIONNAME_AR']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planNameOptions = results.features.map(
                (feature) => feature.attributes.SUBDIVISIONNAME_AR
            );
            results.features.forEach((feature) => {
                this.planGeom[feature.attributes.SUBDIVISIONNAME_AR] =
                    feature.geometry;
            });
        });
    }

    queryPlanDetails(planNme: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=parcel_plane,Parcel_AsBuilt,MadinahAerialPhotography_zone,Plan_Correct,Zoon_Code,Comparison,Balady_2,F3D';
        const queryObject = new Query({
            where: `SUBDIVISIONNAME_AR = N'${planNme}'`,
            returnGeometry: true,
            outFields: [
                'objectid',
                'parcel_plane',
                'Correction_Parcel',
                'MadinahAerialPhotography_zone',
                'Plan_Correct',
                'Zoon_Code',
                'Comparison',
                'Balady_2',
                'F3D'
            ]
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            if (results.features.length > 0) {
                this.planFeature = results.features[0];
                this.objectid = this.planFeature.attributes.OBJECTID;
                this.parcelPlan = this.planFeature.attributes.parcel_plane;
                this.parcelAsbuilt =
                    this.planFeature.attributes.Correction_Parcel;
                this.MAPhotographyZone =
                    this.planFeature.attributes.MadinahAerialPhotography_zone;
                this.planCorrect = this.planFeature.attributes.Plan_Correct;
                this.zoneCode = this.planFeature.attributes.Zoon_Code;
                this.comparison = this.planFeature.attributes.Comparison;
                this.balady2 = this.planFeature.attributes.Balady_2;
                this.F3D = this.planFeature.attributes.F3D;

                //  this.getPlanAttachments();
                //  console.log("fron func")
                //  console.log(feature.attributes)
            }
        });
    }

    onBaladeyaNameChange(event: any) {
        const selectedBaladeya = event.target.value;
        // console.log(this.baladeyaGeometry[selectedBaladeya]);
        this.mapService.mapView.goTo(
            this.baladeyaGeometry[selectedBaladeya].extent
        );
        // debugger;
        this.queryNeighNames(selectedBaladeya);
    }
    onNeighNameChange(event: any) {
        const selectedNeigh = event.target.value;
        this.mapService.mapView.goTo(this.neighGeom[selectedNeigh].extent);
        this.queryPlanNames(selectedNeigh);
    }
    onPlanNameChange(event: any) {
        const selectedPlan = event.target.value;
        this.mapService.mapView.goTo(this.planGeom[selectedPlan].extent);
        this.queryPlanDetails(selectedPlan);
    }

    getPlanAttachments() {
        let that = this;
        that.flyr.queryObjectIds().then(function (objectIds) {
            debugger;
            // Define parameters for querying attachments,
            // query features where objectIds are less than 735,
            // and only query jpeg attachments for these features.
            let attachmentQuery = {
                //objectIds: that.planFeature.attributes.OBJECTID,
                definitionExpression: `OBJECTID =${that.planFeature.attributes.OBJECTID}`,
                attachmentTypes: ['image/jpeg']
            };

            // Only pass in one objectId for attachmentQuery.objectIds
            // if the layer's capabilities.operations.supportsQueryAttachments is false
            that.flyr
                .queryAttachments(attachmentQuery)
                .then(function (attachments) {
                    // Print out all returned attachment infos to the console.
                    //attachmentQuery.objectIds.forEach(function (objectId) {
                    //if (attachments[objectId]) {
                    let attachment = attachments; //[objectId];
                    //console.group("attachment for", objectId);
                    attachment.forEach(function (item) {
                        console.log('attachment id', item.id);
                        console.log('content type', item.contentType);
                        console.log('name', item.name);
                        console.log('size', item.size);
                        console.log('url', item.url);
                        console.groupEnd();
                    });
                    // }
                    // });
                })
                .catch(function (error) {
                    console.log('attachment query error', error);
                });
        });
    }

    savePlanDetails() {
        this.planFeature.attributes.OBJECTID = this.objectid;
        this.planFeature.attributes.parcel_plane = this.parcelPlan;
        this.planFeature.attributes.Parcel_AsBuilt = this.parcelAsbuilt;
        this.planFeature.attributes.MadinahAerialPhotography_zone =
            this.MAPhotographyZone;
        this.planFeature.attributes.Plan_Correct = this.planCorrect;
        this.planFeature.attributes.Zoon_Code = this.zoneCode;
        this.planFeature.attributes.Comparison = this.comparison;
        this.planFeature.attributes.Balady_2 = this.balady2;
        this.planFeature.attributes.F3D = this.F3D;

        const requestBody = {
            updateFeatures: [this.planFeature]
        };

        const options = {
            // globalIdUsed has to be true when adding, updating or deleting attachments
            globalIdUsed: false,
            rollbackOnFailureEnabled: false
        };
        const that = this;
        debugger;
        that.flyr
            .applyEdits(requestBody, options)
            .then((editsResult) => {
                debugger;
                if (editsResult.updateFeatureResults.length > 0) {
                    debugger;
                    const objectId =
                        editsResult.updateFeatureResults[0].objectId;
                    console.log(editsResult);
                }
            })
            .catch((err) => {
                console.log('===============================================');
                console.error(
                    '[ applyEdits ] FAILURE: ',
                    err.code,
                    err.name,
                    err.message
                );
                console.log('error = ', err);
            });

        //  //saving attachment

        //  var fileupld = document.getElementById('file') as any;
        //  if (fileupld.files.length>0) {
        //     var formdata = new FormData();
        //     formdata.append('attachment', fileupld.files[0]);
        //     formdata.append("f","json");
        //     this.flyr.addAttachment(this.planFeature, formdata).then(res=>{
        //       console.log(res);
        //     }).catch(err=>{
        //       console.log(err);
        //     });
        //  }
        //  else{
        //   alert('no file has been attached!!!');
        //  }
    }

    //   saveEdits(){

    //    var planForm:FormData = new FormData();

    //    planForm.append('Id', this.objectid +'');
    //    planForm.append('parcelPlan',this.parcelPlan);
    //    planForm.append('parcelAsbuilt',this.parcelAsbuilt);
    //    planForm.append('MAPhotographyZone',this.MAPhotographyZone);
    //    planForm.append('planCorrect',this.planCorrect);
    //    planForm.append('zoneCode',this.zoneCode);
    //    planForm.append('comparison',this.comparison);
    //    planForm.append('balady2',this.balady2);
    //    planForm.append('F3D',this.F3D);

    //    this.planparcel.savePlanDash(planForm).subscribe((res)=>{

    //    })

    //    // var plnForm:object = new Object();

    //    // planForm['Id']=this.objectid;
    //    // planForm['parcelPlan']=this.parcelPlan;
    //    // planForm['parcelAsbuilt']=this.parcelAsbuilt;
    //    // planForm['MAPhotographyZone']=this.MAPhotographyZone;
    //    // planForm['planCorrect']=this.planCorrect;
    //    // planForm['zoneCode']=this.zoneCode;
    //    // planForm['comparison']=this.comparison;
    //    // planForm['balady2']=this.balady2;
    //    // planForm['F3D']=this.F3D;

    //    // this.plaanparcel.savePlanDash(planForm).subscribe((res)=>{

    //    // })
    //   }
}
